import Trigger from "../../validations/es6/plugins/Trigger";
import Bootstrap from "../../validations/es6/plugins/Bootstrap";
import SubmitButton from "../../validations/es6/plugins/SubmitButton";
import Declarative from "../../validations/es6/plugins/Declarative";

import { getValidationMessage } from "../../utils/i18nHelper";

import subUsersValidationEN from "../../locales/en/subUsersValidation";
import subUsersValidationDE from "../../locales/de/subUsersValidation";
import subUsersValidationES from "../../locales/es/subUsersValidation";
import subUsersValidationFR from "../../locales/fr/subUsersValidation";
import subUsersValidationIT from "../../locales/it/subUsersValidation";
import subUsersValidationHR from "../../locales/hr/subUsersValidation";
import subUsersValidationNL from "../../locales/nl/subUsersValidation";
import subUsersValidationPT from "../../locales/pt/subUsersValidation";

const usernameRegex = /^[A-Za-z0-9]*$/;

export const validationMessages = {
  en: subUsersValidationEN.update,
  de: subUsersValidationDE.update,
  es: subUsersValidationES.update,
  fr: subUsersValidationFR.update,
  it: subUsersValidationIT.update,
  hr: subUsersValidationHR.update,
  nl: subUsersValidationNL.update,
  pt: subUsersValidationPT.update,
};


const createValidationOptions = (lang) => {
  return {
    fields: {
      first_name: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'first_name', 'required', lang)
          }
        }
      },
      last_name: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'last_name', 'required', lang)
          }
        }
      },
      email: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'email', 'required', lang)
          },
          emailAddress:
          {
            message: getValidationMessage(validationMessages, 'email', 'invalid', lang)
          },
        }
      },
      username: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'username', 'required', lang)
          },
          stringCase:{
            case: 'lower',
            message: getValidationMessage(validationMessages, 'username', 'stringCaseLower', lang),
          },
          regexp: {
            regexp: usernameRegex,
            message: getValidationMessage(validationMessages, 'username', 'regexp', lang),
          },
        }
      },
      contract_expiry: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'contract_expiry', 'required', lang)
          }
        }
      },
      sub_user_deal: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'sub_user_deal', 'required', lang)
          },
          between: {
            min: 0,
            max: 100,
            message: getValidationMessage(validationMessages, 'sub_user_deal', 'between', lang)
          }
        }
      },
      street_and_number: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'street_and_number', 'required', lang)
          }
        }
      },
      postal_code: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'postal_code', 'required', lang)
          }
        }
      },
      city: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'city', 'required', lang)
          }
        }
      },
      country: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'country', 'required', lang)
          }
        }
      },
      phone: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'phone', 'required', lang)
          }
        }
      },
    },
    plugins: {
      trigger: new Trigger(),
      bootstrap: new Bootstrap(),
      submitButton: new SubmitButton(),
      declarative: new Declarative({
        html5Input: true
      })
    }
  };
};

export { createValidationOptions };